import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import { uploadImage } from '../../../helpers/api';
import { displayErrorModal } from '../../../helpers/swal';
import style from './style.module.scss';

const MAX_FILE_SIZE_BYTES = 2 * 1024 * 1024; // 2MB

const ImageUpload = ({ slugDate, value = [], onChange }) => {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const onSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !slugDate) return;
    if (file.size > MAX_FILE_SIZE_BYTES) {
      displayErrorModal({ text: `Image must be 2MB or smaller (${(file.size / 1024 / 1024).toFixed(1)}MB selected).` });
      e.target.value = '';
      return;
    }
    setUploading(true);
    try {
      const res = await uploadImage('ai-concept', slugDate, file);
      const url = res?.['ai-conceptUrl'] || res?.['ai-conceptRawUrl'];
      if (url) onChange([...value, url]);
    } catch (err) {
      displayErrorModal({ text: err?.body?.error || err?.message || 'Upload failed' });
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const remove = (i) => onChange(value.filter((_, j) => j !== i));

  return (
    <div className={classNames('mb-3', style.imageUploadBlock)}>
      <h6 className="mb-2">Image inputs</h6>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="d-none"
        onChange={onSelect}
      />
      <Button
        variant="outline-primary"
        size="sm"
        disabled={!slugDate || uploading}
        onClick={() => inputRef.current?.click()}
      >
        {uploading ? 'Uploading…' : 'Add image'}
      </Button>
      {value.length > 0 && (
        <ul className={style.imageList}>
          {value.map((url, i) => (
            <li key={url} className={style.imageItem}>
              <div className={style.imageWrap}>
                <img
                  src={url}
                  alt=""
                  title={url}
                  className={style.imageThumb}
                />
                <button
                  type="button"
                  className={style.removeBtn}
                  onClick={() => remove(i)}
                  aria-label="Remove"
                >
                  ×
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ImageUpload;
